import moment from 'moment';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { formatHours, convertDateFormat } from '../../utilities/timeUtility';

const formatStatToEndTime = (start, finish, locale, timeZone, timeFormat) => {
  const startDate = new Date(start),
        finihshDate = new Date(finish),
        startTime = formatHours(startDate, locale, timeZone, timeFormat),
        finishTime = formatHours(finihshDate, locale, timeZone, timeFormat),
        dateSelected = moment.tz(startDate, timeZone).format(convertDateFormat());

  return `${dateSelected} ${startTime} - ${finishTime}`;
};

export default class VariantsBlock extends Component {
  render() {
    const {
      productTitle, variants, selectedTimeSlot,
      timeZone, priceSymbol, timeFormat, locale,
      selectedResource, selectedLocation, selectDifferentTime,
      selectDifferentTimeWord, enableResourceDropdown, enableLocationDropdown,
      style = {}
    } = this.props;

    return (
      <div className="appointment-block">
        {variants.map(({ title, price }, i) => {
          let header = `${productTitle}`

          if (title != 'Default Title') {
            header += ` / ${title}`
          }

          if (selectedResource && enableResourceDropdown) {
            header = [header, selectedResource.name].join(' - ');
          }

          if (selectedLocation && enableLocationDropdown) {
            header = [header, selectedLocation.name].join(' - ');
          }
          
          return (<div className="information_line bb-1 pb15" key={header + i}>
            <div className="icon">
              <FontAwesomeIcon icon="calendar" style={{ ...style.title, marginRight: '10px' }} />
            </div>
            <div className="inner">
              <span className="heading" style={{...style.title}}>{header}</span>
              <span className="date" style={{fontSize: 'calc(100% - 2px)'}}>
                {selectedTimeSlot
                && formatStatToEndTime(selectedTimeSlot.start, selectedTimeSlot.finish, locale, timeZone, timeFormat)}
              </span>
            </div>
            <div className="price">
              <span className="currency"> {`${priceSymbol} `} </span>
              <span className="value"> {(price).toFixed(2)} </span>
            </div>
          </div>)
        })}
      </div>
    );
  }
}

VariantsBlock.propTypes = {
  productTitle: PropTypes.string,
  variants: PropTypes.array.isRequired,
  selectedTimeSlot: PropTypes.object,
  selectedResource: PropTypes.object,
  locale: PropTypes.string,
  timeZone: PropTypes.string,
  timeFormat: PropTypes.string,
  priceSymbol: PropTypes.any,
  selectDifferentTime: PropTypes.func.isRequired,
  selectDifferentTimeWord: PropTypes.string,
  enableResourceDropdown: PropTypes.bool,
  enableLocationDropdown: PropTypes.bool,
};
